@if (dialogType === 'cancelAppointment') {
<div class="container cancelAppointment">
    <div mat-dialog-title i18n cdkFocusInitial>Cancel appointment?</div>
    <mat-dialog-content i18n>This action will cancel your service appointment.</mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button class="cancel-no-button" [mat-dialog-close]="false">{{noText}}</button>
        <button mat-flat-button class="cancel-yes-button" color="primary" [mat-dialog-close]="true">{{yesText}}</button>
    </mat-dialog-actions>
</div>
}

@if (dialogType === 'onSucessCreateAppointment') {
<div class="container sucess-create-order">
    <div mat-dialog-title i18n>Your Appointment created sucessfully</div>
    <mat-dialog-content i18n>your appointment id is {{appointmentId}} and document no is
        {{appointmentNo}}</mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">Close</button>
        <button mat-flat-button color="primary" [mat-dialog-close]="true">Yes</button>
    </mat-dialog-actions>
</div>
}

@if (dialogType==='serviceDetails') {
<div class="container serviceDetails">
    <mat-dialog-content>
        <div> {{serviceDetails.Name}} </div>
        <div> {{serviceDetails.Description}} </div>
        <div> {{serviceDetails.DescriptionLong}} </div>
        @if (serviceDetails.UnitPrice && serviceDetails.UnitPrice.GrossPrice) {
        <div> {{serviceDetails.UnitPrice.GrossPrice}} </div>
        }
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">Close</button>
    </mat-dialog-actions>
</div>
}

@if (dialogType === 'vehicleVINInfo') {
<div class="car-diagram">
    <!-- Car Image -->
    <img src="car-vector.png" alt="Car" class="car-image">

    <!-- Labels and Indicators -->
    <div class="indicator dash">
        <div class="line"></div>
        <div class="label">Driver’s side interior dash</div>
    </div>

    <div class="indicator door-pillar">
        <div class="line"></div>
        <div class="label">Driver’s side door pillar</div>
    </div>

    <div class="indicator under-hood">
        <div class="line"></div>
        <div class="label">Under hood</div>
    </div>
</div>
}

@if (dialogType === 'oabAppSessionDataDeleteWarning') {
<div class="container session-data-delete-warning">
    <div mat-dialog-title i18n>
        <mat-icon aria-hidden="false" aria-label="Example warning icon" fontIcon="warning"
            routerLink="/home"></mat-icon>
    </div>
    <mat-dialog-content i18n>This action might causes the lose of data on this page.</mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button class="close-button" color="warn" [mat-dialog-close]="false">Close</button>
        <button mat-flat-button color="warn" [mat-dialog-close]="true">Yes</button>
    </mat-dialog-actions>
</div>
}